export default function CompEcoCredits({ prefixCls }: { prefixCls: string }) {
    return <div className={`${prefixCls}-eco-credits`}>3× EcoCredits</div>;
}
